import { render, staticRenderFns } from "./LgsRequirementEdit.vue?vue&type=template&id=38c5230c&"
import script from "./LgsRequirementEdit.vue?vue&type=script&lang=js&"
export * from "./LgsRequirementEdit.vue?vue&type=script&lang=js&"
import style0 from "./LgsRequirementEdit.vue?vue&type=style&index=0&id=38c5230c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports